import { Button } from '@/components/ui/button';
import useNetwork from '@/hooks/use-network';
import { formatCode, formatNumberToCurrency } from '@/lib/utils';
import { GapMagtekSdkContext } from '@/pages/(gapsdk)/_provider/gap-magtek-sdk-provider';
import { SoundContext } from '@/pages/(gapsdk)/_provider/sound-provider';
import { useHandleToast } from '@/pages/(gapsdk)/(authenticated)/hooks/use-toast';
import { MagtekStatusDevice } from '@/types/payment/charge.type';
import { useContext } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import TopNavigation from '../../../_components/top-navigation';

export default function ReviewAddFundPage() {
  const { event: eventSound } = useContext(SoundContext);
  const navigate = useNavigate();
  const { isOnline } = useNetwork();
  const [searchParams] = useSearchParams();
  const { code } = useParams();

  const { event } = useContext(GapMagtekSdkContext);
  const { showToast } = useHandleToast();
  const price = searchParams.get('price');
  const balanceChange = searchParams.get('balance_change');
  const id = searchParams.get('id');

  return (
    <div className="flex size-full flex-col items-center justify-center p-24 top-0 left-0">
      <TopNavigation
        onBack={() => navigate(`/gift-card/add-fund/${code}?id=${id}`)}
      />
      <div className="mx-auto size-full">
        <div className="grid size-full grid-cols-2 gap-12">
          <div className="col-span-1">
            <div className="size-full">
              <div className="flex size-full flex-col">
                <div className="flex grow flex-col items-center justify-center gap-2">
                  <div className="text-2xl font-normal">Total amount</div>
                  <div className="text-9xl font-bold">
                    {formatNumberToCurrency(Number(price))}
                  </div>
                  <div className="text-2xl text-gray-700">
                    Giftcard {formatCode(code ?? '')}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="flex flex-col gap-6">
            <Button
              disabled={Number(price) === 0 || !isOnline}
              onClick={async () => {
                eventSound.playTap();
                const resp = await event.onCheckStatusDevice();
                if (resp === MagtekStatusDevice.active) {
                  navigate(
                    `/gift-card/add-fund/${code}/charge?price=${price}&balance_change=${balanceChange}&id=${id}`,
                  );
                } else {
                  showToast('Device not connected!');
                }
              }}
              variant="outline"
              className="flex size-full items-center justify-center rounded-lg bg-emerald-500 text-5xl font-bold text-white"
            >
              Charge
            </Button>

            <Button
              disabled={!isOnline}
              onClick={() => {
                eventSound.playTap();
                navigate(
                  `/gift-card/add-fund/${code}/cash?price=${price}&balance_change=${balanceChange}&id=${id}`,
                );
              }}
              variant="outline"
              className="flex size-full items-center justify-center rounded-lg bg-blue-500 text-5xl font-bold text-white"
            >
              Cash
            </Button>

            <Button
              disabled={Number(price) === 0 || !isOnline}
              onClick={() => {
                eventSound.playTap();
                navigate(
                  `/gift-card/add-fund/${code}/card-entry?price=${price}&balance_change=${balanceChange}&id=${id}`,
                );
              }}
              variant="outline"
              className="flex size-full items-center justify-center rounded-lg bg-slate-900 text-5xl font-bold text-white"
            >
              Manual card entry
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
